import AsyncComponent from '../../components/HOC/AsyncComponent';

const AsyncValidationLoanApplications = AsyncComponent(() =>
  import('./ValidationRequests')
);

export { AsyncValidationLoanApplications };



// WEBPACK FOOTER //
// ./src/pages/LoanApplication/index.js